<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created() {},
  methods: {},
};
</script>
<style lang="scss">
body {
  font-family: "PingFang SC", system-ui, -apple-system, BlinkMacSystemFont,
    segoe ui, Roboto, Helvetica, Arial, "Microsoft Yahei", sans-serif,
    apple color emoji, segoe ui emoji, segoe ui symbol;
}
img {
  vertical-align: middle;
}
.el-input__inner,
.el-textarea__inner,
.el-button {
  border-radius: 0;
}
.clearfix {
  @include clearfix;
}
// 网站首页变灰
.site-gray {
  filter: grayscale(100%);
}
</style>
